import $ from 'jquery';
import { onLoad }     from 'Core/Events';
import { createSlickChevron } from './SlickChevron';
import BlazeSlider from "blaze-slider";
import { ActualScreen, Breakpoints } from 'Core/Responsiveness';


export const Blog = (() => { 

    const Selector = {
        ARTICLES_SLIDER:           '.js_articles_slider',
		ARTICLES_SLIDER_HOMEPAGE:  '.js_articles_slider_homepage',
		ARTICLES_SLIDER_HOMEPAGE_MOBILE: '.js_articles_slider_homepage_mobile',
    };

    onLoad(articlesSlider);
	onLoad(articlesSliderHomepage);
	onLoad(articlesSliderHomepageMobile);

    function articlesSlider() {
        if($(Selector.ARTICLES_SLIDER).length) {
            $(Selector.ARTICLES_SLIDER).slick({
                infinite: false,
                arrows: true,
                dots: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipe: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 0,
                prevArrow: createSlickChevron('prev', 'poprzedni artykuł'),
                nextArrow: createSlickChevron('next', 'następny artykuł'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 870,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
            $(Selector.ARTICLES_SLIDER).css('visibility', 'visible');
        }
    }

	function articlesSliderHomepage() {
		if($(Selector.ARTICLES_SLIDER_HOMEPAGE).length && ActualScreen.WIDTH >= Breakpoints.MD) {
			$(Selector.ARTICLES_SLIDER_HOMEPAGE).slick({
				infinite: false,
				arrows: false,
				dots: true,
				autoplaySpeed: 4000,
				adaptiveHeight: true,
				swipe: false,
				slidesToShow: 5,
				slidesToScroll: 1,
				rows: 0,
				prevArrow: createSlickChevron('prev', 'poprzedni artykuł'),
				nextArrow: createSlickChevron('next', 'następny artykuł'),
				responsive: [
					{
						breakpoint: 1920,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 1670,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
				]
			});
			$(Selector.ARTICLES_SLIDER_HOMEPAGE).css('visibility', 'visible');
		}
	}

	function articlesSliderHomepageMobile() {
		if ($(Selector.ARTICLES_SLIDER_HOMEPAGE_MOBILE).length && ActualScreen.WIDTH < Breakpoints.MD) {
			new BlazeSlider($(Selector.ARTICLES_SLIDER_HOMEPAGE_MOBILE)[0], {
				all: {
					slidesToShow: 1,
					slidesToScroll: 1,
					loop: true,
					enablePagination: true,
				},
			});
			$(Selector.ARTICLES_SLIDER_HOMEPAGE_MOBILE).css('visibility', 'visible');
		}
	}

})();
import $ from 'jquery';
import { onLoad }     from 'Core/Events';
import { createSlickChevron } from './SlickChevron';
import BlazeSlider from "blaze-slider";
import { ActualScreen, Breakpoints } from 'Core/Responsiveness';


export const Blog = (() => { 

    const Selector = {
        ARTICLES_SLIDER:           '.js_articles_slider',
		ARTICLES_SLIDER_HOMEPAGE:  '.js_articles_slider_homepage',
		ARTICLES_SLIDER_HOMEPAGE_MOBILE: '.js_articles_slider_homepage_mobile',
    };

    onLoad(articlesSlider);
	onLoad(articlesSliderHomepage);
	onLoad(articlesSliderHomepageMobile);

    function articlesSlider() {
        if($(Selector.ARTICLES_SLIDER).length) {
            $(Selector.ARTICLES_SLIDER).slick({
                infinite: false,
                arrows: true,
                dots: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipe: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 0,
                prevArrow: createSlickChevron('prev', 'poprzedni artykuł'),
                nextArrow: createSlickChevron('next', 'następny artykuł'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 870,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
            $(Selector.ARTICLES_SLIDER).css('visibility', 'visible');
        }
    }

	function articlesSliderHomepage() {
		if($(Selector.ARTICLES_SLIDER_HOMEPAGE).length && ActualScreen.WIDTH >= Breakpoints.MD) {
			$(Selector.ARTICLES_SLIDER_HOMEPAGE).slick({
				infinite: false,
				arrows: false,
				dots: true,
				autoplaySpeed: 4000,
				adaptiveHeight: true,
				swipe: false,
				slidesToShow: 5,
				slidesToScroll: 1,
				rows: 0,
				prevArrow: createSlickChevron('prev', 'poprzedni artykuł'),
				nextArrow: createSlickChevron('next', 'następny artykuł'),
				responsive: [
					{
						breakpoint: 1920,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 1670,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
				]
			});
			$(Selector.ARTICLES_SLIDER_HOMEPAGE).css('visibility', 'visible');
		}
	}

	function articlesSliderHomepageMobile() {
		if ($(Selector.ARTICLES_SLIDER_HOMEPAGE_MOBILE).length && ActualScreen.WIDTH < Breakpoints.MD) {
			new BlazeSlider($(Selector.ARTICLES_SLIDER_HOMEPAGE_MOBILE)[0], {
				all: {
					slidesToShow: 1,
					slidesToScroll: 1,
					loop: true,
					enablePagination: true,
				},
			});
			$(Selector.ARTICLES_SLIDER_HOMEPAGE_MOBILE).css('visibility', 'visible');
		}
	}

})();
